module.exports = __webpack_public_path__ + "static/media/Kayttoehdot-UnitSpotter_20180925.e9f90796.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/register/privacy/Kayttoehdot-UnitSpotter_20180925.pdf
// module id = 204
// module chunks = 0